// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"0d63ee7e","517":"5f964c7e","787":"d6f8dc84"}[chunkId] + ".chunk.js";
};